module.exports = __webpack_public_path__ + "12c75227a24fb7bd6497f1027c61869f.pdf";